import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { secondaryPanelLayoutStyles } from 'components/pages/PCM/Products/styles';
import { CampaignPlannerMode } from 'store/dealManagement/types';
import { getCampaignPlannerMode } from 'store/dealManagement/selectors/getCampaignPlannerMode';
import { calculateLeftPositionOffset } from './utils/functions';

type CalculatedStyles = {
  top: string;
  left: string;
  bottom?: string;
  width?: string;
  right?: string;
};

type CalculateSecondaryPanelPositionProps = {
  width?: number;
};

const LINE_PANEL_GAP = 8;

const calculateOverviewLeftPosition = (
  cellRect: DOMRect | undefined,
  contRect: DOMRect | undefined,
  leftOffsetWidth: number,
): string => {
  const containerLeftPosition = contRect?.left ?? 0;
  const cellLeftPosition = cellRect?.left ?? 0;
  const containerRightPosition = contRect?.right ?? 0;
  const cellRightPosition = cellRect?.right ?? 0;

  const isLeftOfCellInView =
    containerLeftPosition < cellLeftPosition && containerLeftPosition < cellLeftPosition - leftOffsetWidth;
  const isRightOfCellInView =
    containerRightPosition > cellRightPosition && containerRightPosition > cellRightPosition + leftOffsetWidth;

  if (isRightOfCellInView) return `${cellRightPosition + LINE_PANEL_GAP}px`;

  if (!isRightOfCellInView && isLeftOfCellInView) return `${cellLeftPosition - leftOffsetWidth - LINE_PANEL_GAP}px`;

  return `${containerLeftPosition}px`;
};

export const calculateSecondaryPanelPosition = ({
  width,
}: CalculateSecondaryPanelPositionProps = {}): CalculatedStyles => {
  const leftOffsetWidth = width ?? 387;

  const isOverviewMode = useSelector(getCampaignPlannerMode) === CampaignPlannerMode.OVERVIEW;

  const location = useLocation();
  const isProduct = location.pathname.includes('product');

  if (isProduct) {
    return {
      top: '60px',
      ...secondaryPanelLayoutStyles,
    };
  }

  if (!isOverviewMode)
    return {
      top: '60px',
      left: calculateLeftPositionOffset(),
      bottom: '16px',
      ...(width ? { width: `${width}px` } : {}),
    };

  const overviewContainerRect = document.getElementById('overview-mode-container')?.getBoundingClientRect();
  const activeColumnContainerRect = document.querySelector(`[data-column-status="active"]`)?.getBoundingClientRect();

  return {
    top: '60px',
    left: calculateOverviewLeftPosition(activeColumnContainerRect, overviewContainerRect, leftOffsetWidth),
    bottom: '64px',
    ...(width ? { width: `${width}px` } : {}),
  };
};
